import { IControl } from "Core/Controls/IControl";
import { ControlDataModel } from "Core/ScreenManager/Models/ControlDataModel";
import { IControlDataModelFacade } from "./Models/ControlDataModelFacade";
import { CONTROL_TYPES } from "Core/Constant";
import type { Dropdown } from "Core/Controls/Dropdown/Dropdown";
import type { TabGrid } from "Core/Screens/Common/LinkEditor/Components/TabGrid/TabGrid";
import type { Text } from "Core/Controls/Text/Text";

export const controlFacade = (control: IControl, tabGrid: TabGrid = null) => {
    
    const contextControl = control;

    const refreshScreen = () =>{
        contextControl.Screen.Refresh();
    }

    const setData = (data: IControlDataModelFacade) =>{
        let controlData = new ControlDataModel();
        controlData.Value = `${data.value}`;
        contextControl.SetData(controlData);
    }

    const getData = (): { value: string, displayValue: string } =>{
        let displayValue = contextControl.GetValue();

         if(contextControl.GetControlTypeName() === CONTROL_TYPES.Dropdown){
            displayValue = (contextControl as Dropdown).GetSelectedItem()?.Label || "";
         }

        return {
            value: contextControl.GetValue(),
            displayValue: displayValue
        }
    }

    const onChanged = (callback: (data?: { value: string, displayValue: string }) => void) => {
        if(contextControl.GetControlTypeName() === CONTROL_TYPES.Dropdown){
            contextControl.On('DROPDOWN_VALUE_SELECTED', this, (eventArgs)=> callback({
                value: eventArgs.data.recordId,
                displayValue: eventArgs.data.displayValue
            }));
        }

        if(contextControl.GetControlTypeName() === CONTROL_TYPES.Grid){
            contextControl.On('ROW_COUNT_CHANGED', this, (eventArgs)=> callback({
                value: String(eventArgs.data.rowCount),
                displayValue: String(eventArgs.data.rowCount)
            }));
        }

        if(contextControl.GetControlTypeName() === CONTROL_TYPES.Text){
            const textControl = contextControl as Text;
            const valueObservable = textControl.ValueObserverable;

            if(valueObservable && typeof valueObservable.subscribe === 'function'){
                // Track previous value to only fire on actual changes
                let previousValue = valueObservable();

                valueObservable.subscribe((newValue) => {
                    if(newValue !== previousValue){
                        previousValue = newValue;
                        callback({
                            value: newValue || '',
                            displayValue: newValue || ''
                        });
                    }
                });
            }
        }
    }

    const setBackgroundColor = (color: string)=>{
        contextControl.BackgroundColor = color;
    }

    const setReadOnly = (value: boolean)=>{
        contextControl.SetReadOnly(value);
    }

    const typeName = contextControl.GetControlTypeName();

    const fieldName = contextControl.GetFieldModel()?.Name || null;

    return { setData, getData, setBackgroundColor, onChanged, setReadOnly, typeName, fieldName, refreshScreen }
}